<template>
  <div>
    <div v-for="(item, index) in menus" :key="index" style="display: inline">
      <v-menu v-if="item.type == 'group'" offset-y nudge-bottom="14">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="mr-2 px-4"
            ><v-icon v-if="item.icon" left>{{ item.icon }}</v-icon>
            {{ item.title }}</v-btn
          >
        </template>

        <v-list>
          <v-list-item
            v-for="(child, childIndex) in item.children"
            :key="childIndex"
            :to="
              child.type == 'page'
                ? '/pages/' + child.page
                : child.type == 'route'
                ? child.url
                : null
            "
            @click="openUrl(child.type, child.url)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ child.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-else
        text
        :to="
          item.type == 'page'
            ? '/pages/' + item.page
            : item.type == 'route'
            ? item.url
            : null
        "
        @click="openUrl(item.type, item.url)"
        class="mr-2 px-4"
      >
        <v-icon v-if="item.icon" left>{{ item.icon }}</v-icon>
        {{ item.title }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { openUrl } from "../../../utils/helper";

export default {
  props: ["menus"],

  methods: {
    openUrl,
  },
};
</script>